import React, {Component, useState, useEffect} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import BlogContent from '../components/BlogContent'; 
import axios from 'axios'; 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import withRouter from '../components/withRouter';
import ForgotContent, {AppWithRouter} from './components/ForgotContent';

class UserForgot extends React.Component{

    constructor(){
        super();  
    }
 
    render()
    { 
        return (
            <div>
                <Header/> 
                <PageHeader title="Forgot Password" />
                <AppWithRouter   />  
                <Footer/>
            </div>
        )
    }
}
export default withRouter(UserForgot);;